import { render } from "./BrandConnectPreview.vue?vue&type=template&id=5ee4f16f"
import script from "./BrandConnectPreview.vue?vue&type=script&lang=js"
export * from "./BrandConnectPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__